import React, { useContext } from 'react';
import { LangContext } from '../../contexts/langContext';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';
import { default_design } from '../../static/default_design';
import { Var } from '../Edu/Variables';
import { Avatar } from '../UiKit/Avatar';
import { AvatarName } from '../UiKit/AvatarName';
import { getColor, getMars, getMoon } from '../utilsDesign';
import { Cross, CrossCompat } from "../Edu/Cross";

export const PentaCrosses = ({ penta }) => {
  const context = { ...useContext(LangContext), ...useContext(SocialContext), ...useContext(StateContext) };
  const $ui = context.$ui;

  const compareColumnWidth = `${(100 / penta.members.length)}%`;

  return (
    <>

      <div className="x_edu_content_title x_edu_content_title--group x_edu_content_title--sticky">
        <div className='x_edu_content_h x_edu_content_h--2'>
          {$ui('penta_cross_title')}
        </div>
      </div>

      <div className="x_edu_content x_edu_content--penta x_edu_content--penta_cross _f _fgap2 _fgrow _f100">


        <div className="x_edu_content_inner _fv _fgap1">
          <div className="x_edu_penta_persons">
            {penta.members.map(one => (
              <div
                key={`penta_cross_${one.avatar.token}`}
                className='x_edu_penta_oneperson'
                style={{ flexBasis: compareColumnWidth }}
              >
                <div className="x_phs_item1 x_phs_item1--100">
                  <Cross
                    design={one.avatar.design}
                    className='penta'
                  />
                </div>
              </div>
            ))}
          </div>

          {penta.members.length === 2 && (
            <CrossCompat
              designA={penta.members[0].avatar.design}
              designB={penta.members[1].avatar.design}
              $ui={$ui}
            />
          )}
        </div>
      </div>

    </>
  );
};